import React, { useMemo } from "react";
import { Nav, Badge } from "react-bootstrap";
import { TabHeaderButton } from "./TabHeaderButton";
import { useSelector } from "react-redux";

export const TabHeaderRow = (props) => {
  const {field, formView } = props;
  const { items, formState, editMode } = formView;
  const { register, control, watch, formState: { errors }, setValue, handleSubmit, onSubmit, getValues } = formState;
  // Subscribe to any form fields the tab `hide` functions depend on (see TabControl).
  (field.watchFields ?? []).forEach((f: string) => watch?.(f));
  const visibleTabs = useSelector((state) => field.items.filter((item) => !item.hide || !item.hide(state, watch)));
  return (
    <div className="card-header p-0 pt-1">
      <Nav variant="tabs">
        {visibleTabs.map((tab, i) => {
          return (
            <TabHeaderButton {...props} tab={tab}/>
          )
        })}
      </Nav>
    </div>
  );
}